var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ypxx"},[_c('tabBar'),_vm._m(0),_c('footers')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zhenshu"},[_c('img',{attrs:{"src":require("../assets/img/xie/zhenshu.jpg")}})])
}]

export { render, staticRenderFns }